// ============================================================
// HistoryPanel — Verlaufs-Sidebar des Assistenten (React-Insel).
// Ersetzt paintHistList()/renderHistList() aus AssistantBar.js;
// Daten liegen in engine.allChats, CSS-Klassen unverändert.
// ============================================================
import { useState } from 'react';
import { useTranslation } from '../../lib/useTranslation.ts';
import { dateShort, time } from '../../../utils/format.ts';
import type { AssistantEngine } from '../../../components/assistant-bar/engine/AssistantEngine.ts';

const fmtDate = (d: string | undefined) => { const day = dateShort(d ?? ''); return day ? day + ' ' + time(d ?? '') : ''; };

interface HistoryPanelProps {
  engine: AssistantEngine;
  onItemContextMenu: (id: string, x: number, y: number) => void;
}

export function HistoryPanel({ engine, onItemContextMenu }: HistoryPanelProps) {
  const t = useTranslation();
  const [filter, setFilter] = useState('');

  const q = filter.trim().toLowerCase();
  const all = engine.allChats;
  const list = all === null ? [] : (q ? all.filter((c) => (c.title || '').toLowerCase().includes(q)) : all);

  return (
    <div className="ab-hist" id="ab-hist">
      <div className="ab-hist-head">
        <button
          className="ab-hist-close-side"
          id="ab-hist-close-side"
          aria-label={t('common.close')}
          onClick={() => engine.setHistCollapsed(true)}
        >{'✕'}</button>
        <span className="ab-hist-title">{t('assistant.historyTitle')}</span>
        <button className="ab-hist-new" id="ab-hist-new" onClick={() => engine.newChat()}>{t('assistant.newChat')}</button>
      </div>
      <div className="ab-hist-search-wrap">
        <input
          id="ab-hist-search"
          className="ab-hist-search"
          type="text"
          placeholder={t('assistant.searchChats')}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
      </div>
      <div className="ab-hist-list" id="ab-hist-list">
        {all === null ? (
          <div className="ab-hist-empty">...</div>
        ) : !list.length ? (
          <div className="ab-hist-empty">{q ? t('assistant.noMatches') : t('assistant.noChats')}</div>
        ) : (
          list.map((c) => (
            <div
              key={c.id}
              className="ab-hist-item"
              onClick={() => engine.openChat(c.id)}
              onContextMenu={(e) => {
                e.preventDefault();
                onItemContextMenu(c.id, e.clientX, e.clientY);
              }}
            >
              <div className="ab-hist-item-title">
                {c.kind === 'voice' && (
                  <span className="material-symbols-rounded ab-hist-kind" title={t('assistant.voiceSession')}>mic</span>
                )}
                {c.title || t('assistant.chatFallback')}
              </div>
              <div className="ab-hist-date">{fmtDate(c.updatedAt || c.createdAt)}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
